module.exports = __webpack_public_path__ + "static/media/Eritrea.ab6190ef.png";